import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Home } from '@/features/home'

const homeSearchSchema = z
  .object({
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute('/_authenticated/generic/integrations/')({
  validateSearch: homeSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/generic/integrations',
        search: {
          language: 'en',
        },
      })
    }
  },
  component: Home,
})
